import { useEffect, useState } from 'react';
import { Link } from 'react-router-dom';
import { Inbox, Mail, Send, Timer } from 'lucide-react';
import { api } from '../lib/api';
import { useI18n } from '../lib/i18n';

type Assigned = {
  id: string; direction: string; department_key: string | null; from_address: string | null; to_address: string | null;
  subject: string | null; claim_id: string | null; claim_number: string | null; homeowner_name: string | null; days: number;
};

/** To Do: emails asignados a MÍ para responder, con los días que llevan asignados. */
export function MyAssignedEmails() {
  const { t } = useI18n();
  const [emails, setEmails] = useState<Assigned[]>([]);
  const [loaded, setLoaded] = useState(false);
  useEffect(() => { api.get<{ emails: Assigned[] }>('/api/me/assigned-emails').then((r) => setEmails(r.emails)).catch(() => setEmails([])).finally(() => setLoaded(true)); }, []);
  if (loaded && emails.length === 0) return null;
  return (
    <div className="card">
      <h2 className="card-title" style={{ margin: 0, display: 'flex', alignItems: 'center', gap: 8 }}>
        <Mail size={16} strokeWidth={1.75} /> {t('inbox.myEmails')} <span className="badge" style={{ fontSize: 'var(--fs-2xs)', background: 'var(--bad-fill)', color: 'var(--bad-fill-ink)' }}>{emails.length}</span>
      </h2>
      <div style={{ display: 'grid', gap: 6, marginTop: 10 }}>
        {emails.map((e) => (
          // Deep-link ?email= → el buzón abre DIRECTO ese email (antes aterrizaba en la lista
          // del depto y en el teléfono, sin auto-selección, parecía que llevaba a otro lado).
          <Link key={e.id} to={`/dept/${e.department_key || 'unassigned'}/inbox?email=${e.id}`}
            /* minWidth:0 + ellipsis en la dirección: un email largo (una sola "palabra") estiraba
               la fila fuera de la tarjeta en el teléfono (reporte del dueño 2026-08-08). */
            style={{ textDecoration: 'none', color: 'inherit', display: 'flex', alignItems: 'center', gap: 10, padding: '8px 10px', borderRadius: 8, border: '1px solid var(--line)', background: 'var(--surface-2)', minWidth: 0 }}>
            <span style={{ display: 'inline-flex', flexShrink: 0 }}>{e.direction === 'in' ? <Inbox size={14} strokeWidth={1.75} /> : <Send size={14} strokeWidth={1.75} />}</span>
            <span style={{ flex: 1, minWidth: 0 }}>
              <div style={{ fontSize: 'var(--fs-sm)', fontWeight: 'var(--fw-semibold)', overflow: 'hidden', textOverflow: 'ellipsis', whiteSpace: 'nowrap' }}>{e.subject || '(no subject)'}</div>
              <div className="muted" style={{ fontSize: 'var(--fs-2xs)', overflow: 'hidden', textOverflow: 'ellipsis', whiteSpace: 'nowrap' }}>{e.from_address || e.to_address || '—'} · {e.homeowner_name || e.claim_number || t('inbox.unassignedTag')}</div>
            </span>
            <span className="badge" style={{ fontSize: 'var(--fs-2xs)', fontWeight: 'var(--fw-bold)', background: e.days >= 3 ? 'var(--red-soft)' : 'var(--accent-soft)', color: e.days >= 3 ? 'var(--red)' : 'var(--accent)' }}><Timer size={12} strokeWidth={1.75} /> {e.days}d</span>
          </Link>
        ))}
      </div>
    </div>
  );
}
